import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "px-6 md:px-8 pt-6 pb-20" }

import { Cog6ToothIcon } from '@heroicons/vue/24/outline'
import { computed, onMounted, ref } from 'vue'

import NeueButton from '@/components/neue/NeueButton.vue'
import NeueLoading from '@/components/neue/NeueLoading.vue'
import { AI_AGENT_GENERAL_SETTINGS } from '@/composables/useAgentSections'
import api from '@/store/api'
import { mapTypeIncludingInactive } from '@/store/mappers'
import AgentsDashboard from '@/view/ai/AgentsDashboard.vue'
import AgentsIntro from '@/view/ai/AgentsIntro.vue'
import { AGENTS_REQUEST, withoutCateringAgents } from '@/view/ai/agentTypes'


export default {
  __name: 'AgentList',
  setup(__props) {

const loading = ref(true)
// Include disabled agents (mapType would filter is_active === false out entirely).
const agents = computed(() => withoutCateringAgents(mapTypeIncludingInactive('agent')))

onMounted(() => {
  api.call('GET', AGENTS_REQUEST).then(() => {
    loading.value = false
  })
})

return (_ctx, _cache) => {
  const _component_router_link = _resolveComponent("router-link")
  const _component_SecondaryTop = _resolveComponent("SecondaryTop")
  const _component_SecondaryNav = _resolveComponent("SecondaryNav")

  return (_openBlock(), _createBlock(_component_SecondaryNav, null, {
    top: _withCtx(() => [
      _createVNode(_component_SecondaryTop, { text: "AI Agents" }, {
        right: _withCtx(() => [
          _createVNode(_component_router_link, { to: _unref(AI_AGENT_GENERAL_SETTINGS) }, {
            default: _withCtx(() => [
              _createVNode(NeueButton, { type: "secondary" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Cog6ToothIcon), { class: "h-4 w-4 mr-1.5" }),
                  _cache[0] || (_cache[0] = _createTextVNode(" General settings ", -1))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _: 1
      })
    ]),
    main: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(NeueLoading, { loading: loading.value }, {
          default: _withCtx(() => [
            (!agents.value.length)
              ? (_openBlock(), _createBlock(AgentsIntro, { key: 0 }))
              : _createCommentVNode("", true),
            _createVNode(AgentsDashboard)
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    _: 1
  }))
}
}

}